import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class ConsumerModel {
  constructor(consumerType: ConsumerType) {
    this.consumerType = consumerType;
  }

  id: number;
  // Common Data
  deviceType: number;
  power: number;
  manufacturer: string;
  deviceTypeName: string;
  count: number; //
  location: 'Private' | 'Public';
  sitePlanAvailable: boolean;
  chargeDeviceAvailable: boolean;
  chargingPointsNumber: number;
  manufacturerDeclaration: boolean;
  extractionPowerMax: number;
  feedPowerMax: number;
  chargingRangeFrom: number;
  chargingRateTo: number;
  interruptibleChargingSystem: boolean;
  acCurrent: number;
  chargingStationInterface: boolean;
  heatPumpType: number;
  powerDIN: number;
  consumptionPower: number;
  heatingPower: number;
  performancePower: number;
  maxConsumptionPower: number;
  maxStartingCurrent: number;
  hotWaterSupplyType: string;
  hotWaterSupplyPowerUsage: number;
  roomHeatingType: string;
  roomHeatingSupplyPowerUsage: number;
  operationalMode: number;
  heatSource: number;
  switchingTime: string;
  enwgP14aModule: 'Module1' | 'Module2' | 'Module3';
  enwgP14aAcceptedAGBs?: boolean;
  rateLimitingType: 'Direct' | 'EMS' | 'NotControlled';
  meterNumber: string;
  noMeterPresent?: boolean;
  meterOperator: string;
  controllability: 'NB' | 'WMSB';
  isP14aStvoException: boolean;
  consumerType: ConsumerType;
}

export type ConsumerForm = TypedForm<Omit<ConsumerModel, 'enwgP14aAcceptedAGBs' | 'noMeterPresent'>>;

export type ConsumerFormV2 = TypedForm<ConsumerModel>;

export type ConsumerType = 'Charger' | 'Storage' | 'EHeating' | 'Misc';
